import { ApiConstant, PathConstant, SystemConstant } from "const";

const en = {
  login: {
    // TEXTS
    TXT_LOGIN: "Login as Administrator",
    TXT_CHANGE_INFO: "Change your information",
    TXT_ADD_AVATAR: "Add your company photo",

    // LABELS
    L_USERNAME: "Username",
    L_PASSWORD: "Password",
    L_REMEMBER_ME: "Remember me",
    L_LOGIN_BUTTON: "Sign in",
    L_NEW_PASSWORD: "Enter your new password",
    L_NEW_PASSWORD_CONFIRMATION: "Confirm your new password",
    L_CONTINUE_BUTTON: "Continue",

    // PLACEHOLDERS
    P_USERNAME: "Enter your username",
    P_PASSWORD: "Enter your password",
    P_NEW_PASSWORD: "Enter your new password",

    // ERROR OBJECT
    ERR_OBJECT: {
      [ApiConstant.STT_UNAUTHORIZED]: "Wrong username or password. Please try again!",
      [ApiConstant.STT_NOT_FOUND]: "Wrong username or password. Please try again!",
      passwordConfirmationNotMatch: "Password and confirm password does not match",
      imageNotValid: "Please choose PNG or JPG",
      somethingWrong: "Something wrong, please try again later",
    },
  },

  common: {
    // OBJECTS
    OBJ_ROUTER_TITLE: {
      [PathConstant.LOGIN]: "Login as Administrator",
      [PathConstant.FIRST_LOGIN]: "Change your company information",
      [PathConstant.COMPANY_MANAGEMENT]: "Company Management",
      [PathConstant.USER_MANAGEMENT]: "User Management",
      [PathConstant.LICENSE]: "License",
      [PathConstant.SETTINGS]: "Settings",
      [PathConstant.SYSTEM_TRACKING]: "System Tracking",
      [PathConstant.BRANCH_MANAGEMENT]: "Branch Management",
      [PathConstant.VERIFY_SMART_OTP]: "SMART OTP Verification",
      [PathConstant.POSITION_MANAGEMENT]: "Position Management",
      [PathConstant.MEDIA_MANAGEMENT]: "Media Management",
      [PathConstant.CHANNEL_MANAGEMENT]: "Channel Management",
      [PathConstant.DEPARTMENT_MANAGEMENT]: "Department Management",
      [PathConstant.DEVICE_MANAGEMENT]: "Device Management",
    },

    OBJ_SIDEBAR_TITLE: {
      companyManagement: "Company Management",
      companyProfile: "Company Profile",
      departmentManagement: "Department Management",
      userManagement: "User Management",
      license: "License",
      settings: "Settings",
      conferenceManagement: "App Management",
      logout: "Logout",
      systemTracking: "System Tracking",
      branchManagement: "Branch Server Management",
      serverMonitoring: "Server Monitoring",
      positionManagement: "Position Management",
      mediaManagement: "Media Management",
      statistic: "Statistic",
      channelManagement: "Channel & Group Management",
      deviceManagement: "Device Management",
    },

    OBJ_ERROR_MSG: {
      wrongPassword: "Wrong password! Please try again",
      passwordConfirmationNotMatch: "Password does not match",
    },

    OBJ_USER_DETAIL: {
      userName: "Name",
      fullName: "Full Name",
      phone: "Phone",
      email: "Email",
      birthday: "Birthday",
      activeStatus: "Active Status",
      joinStatus: "Join Status",
      unit: "Unit",
      department: "Department",
    },

    OBJ_BRANCH_ERROR: {
      updateTime: "Update time",
      fromDate: "From Date",
      toDate: "To Date",
      search: "Search",
      branchServer: "Branch Server",
    },

    OBJ_TABLE_ERROR: {
      number: "No.",
      errorFeature: "Error Name",
      errorComponent: "Error Component",
      time: "Created",
      description: "Description",
      rowsPerPage: "Rows per page",
    },

    OBJ_TABLE_USER_ACTIVITIES: {
      number: "No.",
      user: "User ID",
      action: "Action",
      time: "Time",
      ipAddress: "IP Address",
      rowsPerPage: "Rows per page",
    },

    OBJ_TABLE_BRANCH: {
      number: "No",
      avatar: "Avatar",
      branchName: "Branch Server Name",
      package: "Package",
      packageId: "Package ID",
      license: "License Number",
      existAccount: "Registered Account",
      status: "Status",
      action: "Action",
    },

    OBJ_CONFIRM_RESET: {
      title: "Confirm reset password",
      content: "Do you want to reset password for selected user ?",
      acceptButton: "Accept",
      cancelButton: "Cancel",
    },

    OBJ_BRANCH_ERROR_TYPE: {
      sendMessage: "Send Message",
      audioCall: "Audio Call",
      videoCall: "Video Call",
      audioGroupCall: "Audio Group Call",
      videoGroupCall: "Video Group Call",
      updateProfile: "Update Profile",
    },

    OBJ_RANDOM_ADMIN_PASSWORD: {
      title: "New password",
      content: "New generated administrator's password is: {{password}}",
      close: "Close",
      copy: "Copy password",
    },

    OBJ_USER_ACTIVITIES: {
      [SystemConstant.LOGGER_ACTION_TYPES.LOGIN]: "Login",
      [SystemConstant.LOGGER_ACTION_TYPES.LOGOUT]: "Logout",
      [SystemConstant.LOGGER_ACTION_TYPES.UPDATE_BRANCH_INFORMATION]: "Update branch information",
      [SystemConstant.LOGGER_ACTION_TYPES.ADD_NEW_USERS]: "Add user into branch",
      [SystemConstant.LOGGER_ACTION_TYPES.ACTIVE_USER]: "Active user",
      [SystemConstant.LOGGER_ACTION_TYPES.BLOCK_USER]: "Block user",
      [SystemConstant.LOGGER_ACTION_TYPES.UPDATE_USER_INFORMATION]: "Update user information",
      [SystemConstant.LOGGER_ACTION_TYPES.RESET_USER_PASSWORD]: "Reset user password",
      [SystemConstant.LOGGER_ACTION_TYPES.CHANGE_PASSWORD]: "Change password",
      [SystemConstant.LOGGER_ACTION_TYPES.UPDATE_BRANCH_CONFIGS]: "Update branch configs",
      [SystemConstant.LOGGER_ACTION_TYPES.IMPORT_NEW_USERS_FROM_EXCEL]: "Add new users using Excel file",
      [SystemConstant.LOGGER_ACTION_TYPES.ADD_BRANCH]: "Add branch server",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_BRANCH]: "Delete branch serve",
      [SystemConstant.LOGGER_ACTION_TYPES.ACTIVATE_BRANCH]: "Activate branch",
      [SystemConstant.LOGGER_ACTION_TYPES.DEACTIVATE_BRANCH]: "Deactivate branch",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_UNIT]: "Create unit",
      [SystemConstant.LOGGER_ACTION_TYPES.EDIT_UNIT]: "Edit unit",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_UNIT]: "Delete unit",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_DEPARTMENT]: "Create department",
      [SystemConstant.LOGGER_ACTION_TYPES.EDIT_DEPARTMENT]: "Edit department",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_DEPARTMENT]: "Delete department",
      [SystemConstant.LOGGER_ACTION_TYPES.ADD_DEPARTMENT_USERS]: "Add department users",
      [SystemConstant.LOGGER_ACTION_TYPES.REMOVE_DEPARTMENT_USERS]: "Remove department users",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_UNIT_CHANNEL]: "Create unit channel",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_DEPARTMENT_CHANNEL]: "Create department channel",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_POSITION]: "Create position",
      [SystemConstant.LOGGER_ACTION_TYPES.EDIT_POSITION]: "Edit position",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_POSITION]: "Delete position",
    },

    OBJ_USER_FILTER_STATUS: {
      inactive: "Disabled",
      active: "Joined",
      all: "All",
      pending: "Pending",
    },

    OBJ_UNIT_LIST_TABLE: {
      name: "Unit/department name",
      departmentNumber: "Number of departments",
      employeeNumber: "Number of employees",
    },

    OBJ_UNIT_DETAIL: {
      name: "Unit name",
      branch: "Affiliated with the branch",
    },

    OBJ_UNIT_ERROR: {
      [SystemConstant.UNIT_ERROR.MISSING_PARAMETERS]: "Mising parameters",
      [SystemConstant.UNIT_ERROR.IN_WRONG_FORMAT]: "Unit name is in wrong format",
      [SystemConstant.UNIT_ERROR.DUPLICATED]: "Unit exists",
      [SystemConstant.UNIT_ERROR.CONTAIN_DEPARTMENTS]: "This unit cannot be deleted, it has affiliated departments",
    },

    OBJ_DEPARTMENT_DETAIL: {
      name: "Department name",
      unit: "Affiliated with the unit",
    },

    OBJ_DEPARTMENT_ERROR: {
      [SystemConstant.DEPARTMENT_ERROR.MISSING_PARAMETERS]: "Mising parameters",
      [SystemConstant.DEPARTMENT_ERROR.IN_WRONG_FORMAT]: "Department name is in wrong format",
      [SystemConstant.DEPARTMENT_ERROR.DUPLICATED]: "Department exists",
      [SystemConstant.DEPARTMENT_ERROR.CHANNEL_DUPLICATED]: "Channel exists",
      [SystemConstant.DEPARTMENT_ERROR.CHANNEL_MISSING_PARAMETERS]: "Channel missing parameters",
    },

    OBJ_POSITION_ERROR: {
      [SystemConstant.DEPARTMENT_ERROR.MISSING_PARAMETERS]: "Mising parameters",
      [SystemConstant.DEPARTMENT_ERROR.IN_WRONG_FORMAT]: "Position name is in wrong format",
      [SystemConstant.DEPARTMENT_ERROR.DUPLICATED]: "Position name  is existed",
    },

    OBJ_CHANNEL_DIALOG: {
      unitTitle: "Create unit channel",
      departmentTitle: "Create department channel",
      channelName: "Channel name",
      channelMode: "Channel mode",
      channelManager: "Channel manager",
      unitConfirm: "Do you want to create a channel for this unit?",
      departmentConfirm: "Do you want to create a channel for this department?",
      noUser: "No user",
    },

    OBJ_CREATE_CHANNEL_DIALOG: {
      title: "Create new channel",
      titleGroup: "Create new group",
      channelName: "Channel name",
      groupName: "Group name",
      channelNamePlaceholder: "Enter channel name",
      groupNamePlaceholder: "Enter group name",
      channelMode: "Mode",
      channelAdmin: "Channel admin",
      groupAdmin: "Group admin",
      selectAdmin: "Select admin",
      selectMembers: "Select members",
      selectedMembers: "Selected members",
      searchPlaceholder: "Search by name, phone number",
      selectedCount: "Selected",
      confirm: "Are you sure you want to create?",
      nameRequired: "Please enter a name",
      memberRequired: "Please select at least 1 member",
      adminRequired: "Please select an admin",
      remove: "Remove",
      submitChannel: "Create channel",
      submitGroup: "Create group",
    },

    OBJ_CHANNEL_LIST_TABLE: {
      channelName: "Name",
      memberCount: "Number of members",
      channelType: "Channel type",
      action: "Action",
    },

    OBJ_UPDATE_CHANNEL_DIALOG: {
      title: "Edit",
      totalMembers: "Total members",
      searchPlaceholder: "Search user by name, phone number",
      searchLabel: "Administrator (*)",
      userListTitle: "User list",
      addMember: "Add member",
      colFullName: "Full name",
      colUnit: "Unit",
      colDepartment: "Department",
      colPosition: "Position",
      colRole: "Role",
      colAction: "Action",
      roleAdmin: "Administrator",
      roleMember: "Member",
    },

    OBJ_ADD_CHANNEL_MEMBER_DIALOG: {
      title: "Add users to channel",
      searchLabel: "Administrator (*)",
      searchPlaceholder: "Search user by name, phone number",
      selectedCount: "Selected users",
      colFullName: "Full name",
      colUnit: "Unit",
      colDepartment: "Department",
      colPosition: "Position",
      addMember: "ADD MEMBER",
      cancel: "CANCEL",
    },

    // LABELS
    L_NEED_HELP_BUTTON: "Need help?",
    L_COMPANY_NAME: "Company name",
    L_COMPANY_AVATAR: "Avatar",
    L_CHANGE_COMPANY_AVATAR_BUTTON: "Change Avatar",
    L_CONFIRM_BUTTON: "Confirm",
    L_DISCARD_BUTTON: "Discard",
    L_DELETE_USER_BUTTON: "Delete",
    L_ADD_NEW_USER_BUTTON: "Add New",
    L_JOINED_STATUS: "Joined",
    L_PENDING_STATUS: "Pending",
    L_REFUSED_STATUS: "Refused",
    L_ACTIVE_FUNCTION: "Active Status",
    L_FN_DISABLED: "Disabled",
    L_FN_LOGGED_IN: "Logged in",
    L_FN_NOT_LOGGED_IN: "Not logged in",
    L_FN_SUSPENDED: "Suspended",
    L_REMOVE_BUTTON: "Disable",
    L_CANCEL_BUTTON: "Cancel",
    L_ADD_BUTTON: "Add",
    L_ACTIVE: "Active",
    L_ACTIVATION_STATE: "Activation state",
    L_EXPIRED: "Expired",
    L_UPGRADE_LICENSE: "Upgrade your license",
    L_PASSWORD_LAST_UPDATE: "Last update: {{time}}",
    L_OLD_PASSWORD: "Enter your old password",
    L_UPDATE_PASSWORD_BUTTON: "Update password",
    L_LANGUAGE: "Language",
    L_VIETNAMESE_LANGUAGE: "Vietnamese",
    L_ENGLISH_LANGUAGE: "English",
    L_SAVE_BUTTON: "Save change",
    L_PUBLIC_MODE: "Public",
    L_PRIVATE_MODE: "Private",
    L_PASSWORD_MODE: "Password",
    L_OTP_MODE: "OTP",
    L_ACTIVE_USER: "Active",
    L_INACTIVE_USER: "Inactive",
    L_BRANCH_LIST: "Branch List",
    L_OK: "OK",
    L_CREATE: "Create",
    L_SWITCH_BRANCH: "Switch branch",
    L_ACTIVE_ACTION: "Enable",
    L_INACTIVE_ACTION: "Disable",
    L_UPDATE: "Update",
    L_AGREE: "OK",
    L_SAVE_INFO: "Save Information",
    L_CANCEL_ADD_BRANCH: "Cancel",
    L_STATUS: "Status",
    L_ADD_UNIT_BUTTON: "Add unit",
    L_ACCEPT: "Accept",
    L_DOWNLOAD_FILE: "Download file",
    L_DELETE: "Delete",
    L_CANCEL: "Cancel",
    L_ALL: "All",
    L_CLOSE: "Close",
    L_SELECT_UNIT: "Select unit",
    L_GRANT_ADMIN_PERMISSION: "Grant permission",
    L_REMOVE_ADMIN_PERMISSION: "Remove permission",
    L_GENERATE_PASSWORD: "Generate new password",
    L_UNDERSTOOD: "Understood",

    // PLACEHOLDERS
    P_COMPANY_NAME: "Enter your company name",
    P_ADD_NEW_USER: "Search by user name or phone number",
    P_OLD_PASSWORD: "Enter your old password",
    P_SEARCH: "Search",
    P_SEARCH_UNIT: "Search by unit name",
    P_SEARCH_POSITION: "Search by position name",
    P_POSITION_NAME: "Enter position name",
    P_SEARCH_USER_BY_NAME_PHONE_EMAIL: "Search by user name, phone number or email",
    P_SEARCH_USER_BY_NAME_EMAIL: "Search by user name or email",
    P_SEARCH_USER_BY_NAME_PHONE: "Search by user name or phone number",
    P_SEARCH_APP: "Search by application name",
    P_ADD_NEW_ADMIN: "Search user by name, phone number",

    // TEXTS
    TXT_APP_COPYRIGHT: "Copyright © bGlobal Jsc. All Rights Reserved",
    TXT_COMPANY_PROFILE: "Company profile",
    TXT_INVITE_AGAIN: "Invite again",
    TXT_INVITED: "Invited",
    TXT_CONFIRM_REMOVE_USER_HEADING: "Confirm disable",
    TXT_ADD_NEW_USER: "Add new user",
    TXT_EXPORT_USER_LIST: "Export user list",
    TXT_SELECTED_USER: "Selected user",
    TXT_CONTACT_FOUND: "Contact found",
    TXT_NOT_FOUND: "Not found",
    TXT_LOADING: "Loading",
    TXT_SERVER_EXPIRED: "This server expired",
    TXT_SERVER_ACTIVE: "This server activated with a {{name}} license until",
    TXT_UPGRADE_LICENSE_PHONE_NUM: "Want to upgrade your license? Please call",
    TXT_UPDATE_PASSWORD_SUCCESS: "Update password successfully",
    TXT_INFORMATION: "User information",
    TXT_EDIT_INFO: "Edit user information",
    TXT_RESET_PASSWORD: "Reset password",
    TXT_DETAILS_INFO: "User information",
    TXT_EDIT_USER_INFO: "Edit information",
    TXT_PROFILE_INFO: "Work information",
    TXT_USER_ACTIVITIES: "Channel & Group Activities",
    TXT_CHANNELS_AND_GROUPS: "Joined Channels & Groups",
    TXT_NO_CHANNELS_OR_GROUPS: "No channels or groups joined",
    TXT_ROLE_ADMIN: "Admin",
    TXT_ROLE_MEMBER: "Member",
    TXT_ORGANIZATION: "Organization",
    TXT_ALL: "All",
    TXT_GROUP_TYPE_CHANNEL: "Channel",
    TXT_GROUP_TYPE_GROUP: "Group",
    TXT_MODE: "Mode",
    TXT_SETTINGS_THEME: "Appearance",
    TXT_SETTINGS_SERVER: "Server Information",
    TXT_BRANCH_MODE: "Branch mode",
    TXT_LOGIN_MODE: "Login mode",
    TXT_ADD_BRANCH: "Add branch",
    TXT_CONFIRM_DELETE_BRANCH: "Do you want to delete this branch?",
    TXT_NOTIFICATION_ERROR_TITLE: "Error",
    TXT_NOTIFICATION_ERROR_CONTENT: "Invalid information",
    TXT_CONFIRM_ACTIVE_USER: "Confirm active user",
    TXT_DELETE_FAIL: "An error occurred. Cannot delete Branch",
    TXT_INACTIVE_ERROR: "The user you selected is already in the Inactive state. Please choose another user",
    TXT_ACTIVE_ERROR: "The user you selected is already in the Active state. Please choose another user",
    TXT_INVALID_DATE: "Invalid date. Please choose again.",
    TXT_DATE_NULL: "From Date field and To Date field are not null",
    TXT_UPDATE_ERROR: "An error occurred during execution. Please try again.",
    TXT_UPDATE_SUCCESS: "Successfully updated.",
    TXT_EMAIL_WRONG: "Email address is not valid. Please check again.",
    TXT_UPLOAD_DUPLICATE_DATA: "Duplicate data. Please check again!",
    TXT_UPLOAD_MAX_USER_WRONG: "The list has exceeded the number of registered people, please check again!",
    TXT_CONFIRM_CANCEL_CREATE_BRANCH: "Are you sure to cancel the process of creating a new Branch?",
    TXT_OF: "of",
    TXT_MORE_THAN: "more than",
    TXT_FAILURE_VALIDATION: "The data submitted is invalid. Please check again.",
    TXT_ADD_USER_SUCCESS: "Add new user successfully",
    TXT_SYSTEM_ERROR_LIST: "System errors",
    TXT_USER_ACTIVITY_LIST: "User activities",
    TXT_VERIFY_SMART_OTP_CONTENT:
      "We have sent the verification code to your phone number. Please enter the verification code to continue logging in.",
    TXT_RESEND_OTP: "Resend OTP code",
    TXT_VERIFY_OTP: "Verify OTP code",
    TXT_SMART_OTP_RETRY: "Incorrect SMART OTP code.\nYou have {{retry}} time(s) left to enter SMART OTP",
    TXT_SMART_OTP_BLOCK:
      "You have entered more than the allowed number of times.\nYou will be re-entered the OTP code after 5 minutes",
    TXT_SMART_OTP_EXPIRED: "Your OTP code has expired",
    TXT_SMART_OTP_LIMIT_ERROR: "The current OTP code is still valid.",
    TXT_GRANT_ADMIN_PERMISSION: "Grant administrator permission",
    TXT_REMOVE_ADMIN_PERMISSION: "Remove administrator permission",
    TXT_GENERATE_NEW_ADMIN_PASSWORD: "Generate new administrator's password",
    TXT_NEW_ADMIN_PASSWORD: "New administrator's password is: {{password}}",
    TXT_CONFIRM_ACTION: "Are you sure you want to perform this action?",
    TXT_LOGIN_EXPIRED: "Login session has expired",
    TXT_FILL_FORM: "Fill Form",
    TXT_UPLOAD_FILE: "Upload File",
    TXT_ADD_NEW: "Add user",
    TXT_USER: "User Name",
    TXT_UNIT: "Unit",
    TXT_DEPARTMENT: "Department",
    TXT_POSITION: "Position",
    TXT_STATUS: "Status",
    TXT_DOWNLOAD_SAMPLE_FILE: "Download sample file",
    TXT_IMPORT_SUCCESS: "Upload file successfully",
    TXT_IMPORT_SUCCESS_MSG: "User will be receive the invitation into the branch server in their emails",
    TXT_IMPORT_FAILURE: "Upload file failure",
    TXT_IMPORT_FAILURE_MSG:
      "This file cannot upload because of the wrong information\n Please download the description file to edit",
    TXT_FILE_NOT_VALID: "File is invalid",
    TXT_CHOOSE_ANOTHER_FILE_MSG: "Please upload another file",
    TXT_TITLE_UNIT_LIST: "Unit/Department List",
    TXT_CHOOSE_UNIT: "Choose unit",
    TXT_CHOOSE_DEPARTMENT: "Choose department",
    TXT_CHOOSE_POSITION: "Choose position",
    TXT_POSITION_NAME: "Position name",
    TXT_UNIT_NAME: "Unit name",
    TXT_DEPARTMENT_NAME: "Department name",
    TXT_CREATED_AT: "Created at",
    TXT_CREATE_POSITION_TITLE: "Create new position",
    TXT_EDIT_POSITION_TITLE: "Update position information",
    TXT_FROM_UNIT: "From Unit",
    TXT_FROM_DEPARTMENT: "From Department",
    TXT_CREATE_DEPARTMENT: "Create department",
    TXT_MEMBER_MANAGEMENT: "Member management",
    TXT_CREATE_CHANNEL: "Create channel",
    TXT_DELETE: "Delete",
    TXT_CREATE_UNIT: "Create unit",
    TXT_EDIT_UNIT: "Edit unit",
    TXT_ENTER_UNIT_NAME: "Enter unit name",
    TXT_CONFIRM_DELETE_UNIT: "Deleting a unit will also delete all affiliated departments. Are you sure to do it?",
    TXT_CONFIRM_DELETE_DEPARTMENT:
      "Deleting a department will also delete all affiliated positions. Are you sure to do it?",
    TXT_CREATE_DEPARTMENT_TITLE: "Create channel",
    TXT_EDIT_DEPARTMENT: "Edit department",
    TXT_ENTER_DEPARTMENT_NAME: "Enter department name",
    TXT_MEMBER_LIST: "Member list",
    TXT_ADD_MEMBER: "Add member",
    TXT_CREATE_POSITION_SUCCESS: "Create position successfully",
    TXT_UPDATE_POSITION_SUCCESS: "Update position successfully",
    TXT_DELETE_POSITION_SUCCESS: "Delete position successfully",
    TXT_CONFIRM_DELETE_POSITION: "Do you want to delete this positions?",
    TXT_CREATE_UNIT_SUCCESS: "Create unit successfully",
    TXT_UPDATE_UNIT_SUCCESS: "Update unit successfully",
    TXT_CREATE_UNIT_FAIL: "Create unit failure",
    TXT_UNIT_DUPLICATED: "Unit name is duplicated",
    TXT_INVALID_UNIT_NAME: "Unit name is invalid",
    TXT_MISSING_FORM_PARAMS: "Missing form parameters",
    TXT_NO_DEPARTMENTS: "No department found",
    TXT_ADD_MEMBER_DIALOG: "Add member",
    TXT_CONFIRM_DELETE_MEMBER: "Do you want to delete this member?",
    TXT_NO_UNITS: "No unit found",
    TXT_UNIT_CONTAIN_DEPARTMENTS: "This unit cannot be deleted, it has affiliated departments",
    TXT_DELETE_UNIT_SUCCESS: "Delete unit successfully",
    TXT_CREATE_DEPARTMENT_SUCCESS: "Create department successfully",
    TXT_UPDATE_DEPARTMENT_SUCCESS: "Update department successfully",
    TXT_CREATE_DEPARTMENT_FAIL: "Create department failure",
    TXT_DEPARTMENT_DUPLICATED: "Department name duplicated",
    TXT_INVALID_DEPARTMENT_NAME: "Department name invalid",
    TXT_DEPARTMENT_CONTAIN_POSITIONS: "This department cannot be deleted, it has a subordinate position",
    TXT_DELETE_DEPARTMENT_SUCCESS: "Delete department successfully",
    TXT_CREATE_CHANNEL_SUCCESS: "Create channel successfully",
    TXT_CREATE_CHANNEL_FAIL: "Create channel failure",
    TXT_CHANNEL_DUPLICATED: "Channel is existed",
    TXT_ADD_MEMBER_SUCCESS: "Add member successfully",
    TXT_DELETE_MEMBER_SUCCESS: "Delete member successfully",
    TXT_PHONE_DUPLICATED: "Phone number is existed. The invitation has been sent back.",
    TXT_DATA_WRONG_FORMAT: "The submitted data is in wrong format",
    TXT_CREATE_ACCOUNT_SUCCESS: "Create account successfully",
    TXT_CREATE_ACCOUNT_FAIL: "Create account failure",
    TXT_INVITE_SUCCESS: "The invitation is sent",
    TXT_INVITE_FAIL: "The invitation sent failed",

    // Conference/App Management
    TXT_APPLICATION_NAME: "Application name",
    TXT_DESCRIPTION: "Description",
    TXT_ADMINISTRATOR: "Administrator",
    TXT_ADD_ADMINISTRATOR: "Add administrator",
    TXT_EDIT_ADMINISTRATOR: "Change administrator",
    TXT_STT: "No.",
    TXT_FULL_NAME: "Full name",
    TXT_PHONENUMBER: "Phone number",
    TXT_PASSWORD: "Password",
    TXT_DELEGATION: "Delegation",
    TXT_ROLE: "Role",
    TXT_FOLDER_NAME: "Folder name",
    TXT_EDIT_APP_INFO: "Edit application info",
    TXT_USERNAME: "User name",
    TXT_ACTION: "Action",
    TXT_ADD_USER: "Add user",
    TXT_DELETE_USER: "Delete user",
    TXT_DELETE_USER_FROM_LIST: "Do you want to delete these users from the list?",
    TXT_BIRTHDAY: "Birthday",
    TXT_CHOOSE_MULTI_ROLE: "You can select more than one role",
    TXT_ROLE_DESCRIPTION: "Role description",
    TXT_CREATED_TIME_DATE: "Created info",
    TXT_APP_CONFIG: "Application configuration",
    TXT_APP_TITLE: "Application title",
    TXT_TITLE: "Title",
    TXT_APP_FEATURES: "Application features",
    TXT_MEETING_DOCUMENTS: "Meeting documents",
    TXT_SEATING_POSITION: "Seating position",
    TXT_SUPPORT: "Support",
    TXT_MEETING_FEEDBACK: "Meeting feedback",
    TXT_PERSONAL_NOTES: "Personal notes",
    TXT_SAVE_CONFIG: "Save configuration",
    TXT_ADD_ROLE: "Add role",
    TXT_EDIT_ROLE: "Edit role",
    TXT_CONFIG_APP: "App configuration",
    TXT_VIEW_DETAIL: "View detail",
    TXT_DELETE_ADMIN: "Delete administrator",
    TXT_ADD_ADMIN: "Add administrator",
    TXT_CONFIRM_DELETE_ADMIN_TITLE: "Delete administrator",
    TXT_CONFIRM_DELETE_ADMIN_TEXT: "Do you want to remove this administrator from the list?",

    // User Management - additional
    TXT_ENTER_NEW_PASSWORD: "Enter new password",
    TXT_CHANGE_PASSWORD: "Change password",
    TXT_CHANGE_PASSWORD_TITLE: "After changing the password, the account will be logged out from all devices",
    TXT_GRANT_ADMIN_PERMISSION_TITLE: "Do you want to grant administrator permission to this user?",
    TXT_REMOVE_ADMIN_PERMISSION_TITLE: "Do you want to remove administrator permission of this user?",
    TXT_GENERATE_NEW_ADMIN_PASSWORD_TEXT: "After generating a new password, the account will be logged out from all devices",
    TXT_INVALID_FILE_COLUMNS_MSG: "Your file has missing or extra columns compared to the requirements. Please compare\nwith the sample file to ensure complete and accurate data before proceeding.",
    TXT_UPDATE_ROLE_ACCOUNT_SUCCESS: "Update administrator successfully",
    TXT_CONFIRM_DELETE_MEMBER_TITLE: "Delete user",
    TXT_CONFIRM_DELETE_MEMBER_TEXT: "Do you want to delete this user?",
    TXT_LOGOUT_BUTTON: "Logout",
    TXT_LOGOUT_TITLE: "Logout from the system",
    TXT_LOGOUT_TEXT: "Do you want to logout from the system?",
    TXT_DATA_NOT_FOUND: "Data not found",
    TXT_TOTAL_ADMINS: "Total administrators",
    TXT_PHONE_INVALID: "Invalid phone number",
    TXT_PASSWORD_CHANGE_SUCCESS_TITLE: "Password changed successfully",
    TXT_PASSWORD_CHANGE_SUCCESS_TEXT: "Your password has been changed successfully. The system will logout accounts using the old password. Please login again!",

    // DHD - Copy Password
    TXT_COPY_PASSWORD_TITLE: "Copy password",
    TXT_UPDATE_PASSWORD: "The system has updated the password.",
    TXT_COPY_PASSWORD: "Please copy and send to the user",
    TXT_COPY_ACTION: "Copy",
    TXT_COPY_SUCCESS: "Password copied",
    TXT_COPY_FAILED: "Copy failed, please try again",

    // Error objects
    OBJ_CONFERENCE_ERROR: {
      0: "Missing parameters",
      1: "Application name is in wrong format",
      2: "Application name already exists",
    },

    OBJ_ROLE_ACCOUNT_ERROR: {
      0: "Missing parameters",
      1: "Data is in wrong format",
      2: "Data already exists",
    },

    // Channel management
    TXT_TIMEOUT: "Connection to server lost, please try again",
    TXT_PRIVATE_CHANNEL: "Private channel",
    TXT_PUBLIC_CHANNEL: "Public channel",
    TXT_NO_CHANNEL: "No channel or group has been created on the server yet",
    TXT_DISSOLVE_CHANNEL: "Dissolve channel",
    TXT_DISSOLVE_CHANNEL_SUCCESS: "Channel dissolved successfully",
    TXT_DISSOLVE_CHANNEL_FAIL: "Failed to dissolve channel",
    TXT_GRANT_CHANNEL_ADMIN_SUCCESS: "Admin privileges granted to user",
    TXT_GRANT_CHANNEL_ADMIN_FAIL: "Failed to grant admin privileges to user",
    TXT_GRANT_CHANNEL_ADMIN_BTN: "Grant admin",
    TXT_REVOKE_CHANNEL_ADMIN_SUCCESS: "Admin privileges removed from user",
    TXT_REVOKE_CHANNEL_ADMIN_FAIL: "Failed to revoke admin privileges from user",
    TXT_REVOKE_CHANNEL_ADMIN_BTN: "Revoke admin",
    TXT_REVOKE_CHANNEL_ADMIN_DISABLED: "Channel must have at least 1 administrator",
    TXT_REMOVE_CHANNEL_MEMBER_SUCCESS: "User removed from channel",
    TXT_REMOVE_CHANNEL_MEMBER_FAIL: "Failed to remove user",
    TXT_REMOVE_CHANNEL_MEMBER_BTN: "Remove user from channel",
    TXT_REMOVE_CHANNEL_MEMBER_DISABLED_MIN: "Channel must have at least 3 members",
    TXT_ADD_CHANNEL_MEMBER_SUCCESS: "User added to channel",
    TXT_ADD_CHANNEL_MEMBER_FAIL: "Failed to add user to channel",
    TXT_SEARCH_CHANNEL_PLACEHOLDER: "Search by name",
    TXT_CHANNEL_SIZE_ALL: "All",
    TXT_CHANNEL_SIZE_SMALL: "Small (< 10 members)",
    TXT_CHANNEL_SIZE_MEDIUM: "Medium (11-50 members)",
    TXT_CHANNEL_SIZE_LARGE: "Large (51-100 members)",
    TXT_CHANNEL_SIZE_VERY_LARGE: "Very large (> 100 members)",
    TXT_CHANNEL_SIZE_FILTER: "Group size",
    TXT_GROUP_TYPE_FILTER: "Type",
    TXT_REVOKE_CHANNEL_ADMIN_TITLE: "Remove admin privileges",
    TXT_REVOKE_CHANNEL_ADMIN_CONTENT: "Do you want to remove this user's admin privileges in the channel?",
    TXT_ADD_CHANNEL_ADMIN_TITLE: "Grant admin privileges",
    TXT_ADD_CHANNEL_ADMIN_CONTENT: "Do you want to grant this user admin privileges in the channel?",
    TXT_DELETE_CHANNEL_MEMBER_TITLE: "Remove user from channel",
    TXT_DELETE_CHANNEL_MEMBER_CONTENT: "Do you want to remove this user from the channel?",
    TXT_ADD_CHANNEL_MEMBER: "Add user to channel",
    TXT_ADD_CHANNEL_MEMBER_CONTENT: "Do you want to add this user to the channel?",
    TXT_MEMBER_NOT_EXISTED: "Member is not existed in this channel",

    // Group management
    TXT_DISSOLVE_GROUP: "Dissolve group",
    TXT_DISSOLVE_GROUP_SUCCESS: "Group dissolved successfully",
    TXT_DISSOLVE_GROUP_FAIL: "Failed to dissolve group",
    TXT_GRANT_GROUP_ADMIN_SUCCESS: "Admin role granted to user",
    TXT_GRANT_GROUP_ADMIN_FAIL: "Failed to grant admin role to user",
    TXT_GRANT_GROUP_ADMIN_BTN: "Grant admin",
    TXT_REVOKE_GROUP_ADMIN_SUCCESS: "Admin role removed from user",
    TXT_REVOKE_GROUP_ADMIN_FAIL: "Failed to revoke admin role from user",
    TXT_REVOKE_GROUP_ADMIN_BTN: "Revoke admin",
    TXT_REVOKE_GROUP_ADMIN_DISABLED: "Group must have at least 1 admin",
    TXT_REMOVE_GROUP_MEMBER_SUCCESS: "User removed from group",
    TXT_REMOVE_GROUP_MEMBER_FAIL: "Failed to remove user",
    TXT_REMOVE_GROUP_MEMBER_BTN: "Remove user from group",
    TXT_REMOVE_GROUP_MEMBER_DISABLED_MIN: "Group must have at least 3 members",
    TXT_ADD_GROUP_MEMBER_SUCCESS: "User added to group",
    TXT_ADD_GROUP_MEMBER_FAIL: "Failed to add user to group",
    TXT_ADD_GROUP_MEMBER: "Add user to group",
    TXT_ADD_GROUP_MEMBER_CONTENT: "Do you want to add this user to the group?",
    TXT_GROUP_NOT_EXISTED: "Member does not exist in this group",
    TXT_REVOKE_GROUP_ADMIN_TITLE: "Remove admin role",
    TXT_REVOKE_GROUP_ADMIN_CONTENT: "Do you want to remove this user's admin role in the group?",
    TXT_ADD_GROUP_ADMIN_TITLE: "Grant admin role",
    TXT_ADD_GROUP_ADMIN_CONTENT: "Do you want to grant this user admin role in the group?",
    TXT_DELETE_GROUP_MEMBER_TITLE: "Remove user from group",
    TXT_DELETE_GROUP_MEMBER_CONTENT: "Do you want to remove this user from the group?",

    // FORMATS
    FM_REMOVE_SINGLE_PERSON: "Disable {{name}} from this server?",
    FM_REMOVE_MULTIPLE_PEOPLE: "Disable {{number}} people from this server?",
    FM_ACTIVE_SINGLE_PERSON: "Do you want active {{name}}?",
    FM_ACTIVE_MULTIPLE_PERSON: "Do you want active {{number}} users?",
    FM_UPLOAD_PHONE_FORMAT_WRONG: "{{number}} user(s) has(have) wrong phone number format, please check again!",
    FM_COUNTDOWN_OTP: "(00:{{ time }})",

    FM_TOTAL_CHANNELS: "Total: {{number}}",
    FM_TOTAL_GROUPS: "Total: {{number}}",
    FM_TOTAL_MEMBERS_IN_GROUP: "Total members in {{type}} {{name}}",
    FM_DISSOLVE_CHANNEL_CONTENT: "Do you want to dissolve channel {{groupName}}?",
    FM_DISSOLVE_GROUP_CONTENT: "Do you want to dissolve group {{groupName}}?",
    FM_DISSOLVE_BATCH_CONTENT: "Do you want to dissolve {{number}} selected channel(s)/group(s)?",
    FM_DISSOLVE_BATCH_SUCCESS: "Successfully dissolved {{number}} channel(s)/group(s)",
    FM_DISSOLVE_BATCH_FAIL: "Failed to dissolve {{number}} channel(s)/group(s)",
    TXT_DISSOLVE_SELECTED: "Dissolve ({{number}})",

    // Statistic
    TXT_STATISTIC_USER_OVERVIEW: "User Overview",
    TXT_STATISTIC_MESSAGE_OVERVIEW: "Message Overview",
    TXT_STATISTIC_CALL_OVERVIEW: "Call Overview",
    TXT_STATISTIC_GROUP_OVERVIEW: "Channel/Group Activity Overview",
    TXT_STATISTIC_EXPORT: "Export list",
    TXT_STATISTIC_DATA_UPDATED_AT: "*Data last updated at {{time}}",
    TXT_STATISTIC_USER_COUNT_IN: "Number of users in {{name}}",
    TXT_STATISTIC_USER_STATUS: "User status",
    TXT_STATISTIC_TOTAL_USERS: "Total users",
    TXT_STATISTIC_TOTAL_UNITS: "Total units",
    TXT_STATISTIC_TOTAL_DEPARTMENTS: "Total departments",
    TXT_STATISTIC_JOINED: "Joined",
    TXT_STATISTIC_NOT_JOINED: "Not joined",
    TXT_STATISTIC_FN_DISABLED: "Disabled",
    TXT_STATISTIC_FN_LOGGED_IN: "Logged in",
    TXT_STATISTIC_FN_NOT_LOGGED_IN: "Not logged in",
    TXT_STATISTIC_FN_SUSPENDED: "Suspended",
    TXT_STATISTIC_TOTAL_MESSAGES_SENT: "Total messages sent successfully:",
    TXT_STATISTIC_MESSAGES_UNIT: "messages",
    TXT_STATISTIC_NUM_MESSAGES: "Number of messages",
    TXT_STATISTIC_TOTAL_CALLS_MADE: "Total calls made:",
    TXT_STATISTIC_CALLS_UNIT: "calls",
    TXT_STATISTIC_NUM_CALLS: "Number of calls",
    TXT_STATISTIC_CALL_STATUS_RATIO: "Call status ratio",
    TXT_STATISTIC_CALL_SUCCESS: "Successful calls",
    TXT_STATISTIC_CALL_MISSED: "Missed calls",
    TXT_STATISTIC_CALL_CANCELED: "Canceled calls",
    TXT_STATISTIC_TOTAL_CALLS: "Total calls",
    TXT_STATISTIC_USER_LIST_IN: "User list in {{title}}",
    TXT_STATISTIC_USER_COUNT_TITLE_IN: "Number of users in {{title}}: ",
    TXT_STATISTIC_JOINED_USER_LIST: "Joined user list",
    TXT_STATISTIC_JOINED_USER_COUNT: "Number of joined users in {{title}}: ",
    TXT_STATISTIC_NOT_JOINED_USER_LIST: "Not joined user list",
    TXT_STATISTIC_NOT_JOINED_USER_COUNT: "Number of not joined users in {{title}}: ",
    TXT_STATISTIC_PEOPLE_UNIT: "people",

    // Executive Summary Cards
    TXT_CARD_TOTAL_USERS: "Total Users",
    TXT_CARD_ALL_ACCOUNTS: "All accounts",
    TXT_CARD_JOINED: "Joined",
    TXT_CARD_PENDING: "Pending",
    TXT_CARD_DISABLED: "Disabled",
    TXT_CARD_SUSPENDED: "Suspended",
    TXT_CARD_ONLINE_USERS: "Online Users",
    TXT_CARD_DETAILS: "Details →",
    TXT_CARD_CONNECTED_APP: "connected to App",
    TXT_CARD_REALTIME_ONLINE: "Real-time Online",
    TXT_CARD_TOTAL_MESSAGES: "Total Messages",
    TXT_CARD_ALL_TIME: "All time",
    TXT_CARD_MESSAGES_SENT: "Messages sent:",
    TXT_CARD_DIRECT_MESSAGES: "Direct messages:",
    TXT_CARD_GROUP_MESSAGES: "Channels & groups:",
    TXT_CARD_LAST_UPDATED: "Last updated:",
    TXT_CARD_REFRESH: "Refresh",
    TXT_CARD_AUTO_REFRESH: "Auto refresh",
    TXT_CARD_REFRESH_OFF: "Off",
    TXT_CARD_ACTIVITY_STATUS: "Activity status:",
    TXT_CARD_ACTIVE: "Active",
    TXT_CARD_FILES_STORAGE: "Files & Storage",
    TXT_CARD_UPLOADED_FILES: "Uploaded files",
    TXT_CARD_TOTAL_FILES: "Total files:",
    TXT_CARD_STORAGE_USED: "Storage used:",
    TXT_CARD_USER_ENGAGEMENT: "User Activity (DAU / WAU / MAU)",
    TXT_CARD_DAU_DAILY: "DAU (Daily - 24h):",
    TXT_CARD_WAU_WEEKLY: "WAU (Weekly - 7 days):",
    TXT_CARD_MAU_MONTHLY: "MAU (Monthly - 30 days):",
    TXT_CARD_CALLS_CONFERENCES: "Calls & Conferences",
    TXT_CARD_CALLS_UNIT: "calls",
    TXT_CARD_DIRECT_CALLS: "Direct calls (1-1):",
    TXT_CARD_CALL_SUCCESS: "Success",
    TXT_CARD_CALL_MISSED: "Missed/Canceled",
    TXT_CARD_GROUP_CALLS: "Group calls:",
    TXT_CARD_GROUP_SESSIONS: "Group sessions",
    TXT_CARD_CHANNELS_GROUPS: "Channels & Groups",
    TXT_CARD_CHANNELS_GROUPS_UNIT: "Channels & Groups",
    TXT_CARD_CHANNELS_COUNT: "Channels:",
    TXT_CARD_GROUPS_COUNT: "Groups:",
    TXT_CARD_PUBLIC: "Public",
    TXT_CARD_PRIVATE: "Private",
    TXT_CARD_DISCUSSION_GROUPS: "Discussion groups",


    // Statistic - SelectDateTime
    TXT_DATE_TODAY: "Today",
    TXT_DATE_LAST_7_DAYS: "Last 7 days",
    TXT_DATE_LAST_1_MONTH: "Last 1 month",
    TXT_DATE_LAST_3_MONTHS: "Last 3 months",
    TXT_DATE_BY_YEAR: "By year",
    TXT_DATE_CUSTOM: "Custom",

    // Statistic - Table headers
    TXT_STATISTIC_COL_STT: "No.",
    TXT_STATISTIC_COL_TYPE: "Type",
    TXT_STATISTIC_COL_NAME: "Name",
    TXT_STATISTIC_COL_MEMBER_COUNT: "Number of members",
    TXT_STATISTIC_COL_TOTAL_MESSAGES: "Total messages sent",
    TXT_STATISTIC_COL_LAST_ACTIVE: "Last active",

    // MediaManagement
    TXT_MEDIA_MESSAGE_LIST: "Message list",
    TXT_MEDIA_ACCOUNT_INFO: "Account information",
    TXT_MEDIA_COMPOSE_NEW: "Compose new message",
    TXT_MEDIA_COMPOSE: "Compose message",
    TXT_MEDIA_SCHEDULE_SEND: "Schedule message",
    TXT_MEDIA_SCHEDULE_BTN: "Schedule send",
    TXT_MEDIA_SEND: "Send",
    TXT_MEDIA_SAVE_DRAFT: "Save draft",
    TXT_MEDIA_SAVE_DRAFT_TITLE: "Save draft",
    TXT_MEDIA_SAVE_DRAFT_CONTENT: "Do you want to save as draft?",
    TXT_MEDIA_SAVE_DRAFT_BTN: "Save",
    TXT_MEDIA_EXIT: "Exit",
    TXT_MEDIA_INPUT_PLACEHOLDER: "Enter description",
    TXT_MEDIA_MAX_CHARS_ERROR: "Maximum 500 characters",
    TXT_MEDIA_CONTENT_EXCEEDS: "Message content exceeds 500 characters!",
    TXT_MEDIA_CONTENT_EMPTY: "Message content cannot be empty!",
    TXT_MEDIA_SEND_SUCCESS: "Message sent successfully",
    TXT_MEDIA_SCHEDULE_SUCCESS: "Message scheduled successfully",
    TXT_MEDIA_DRAFT_SAVED: "Draft saved",
    TXT_MEDIA_CANCEL_SCHEDULE: "Scheduled message canceled",
    TXT_MEDIA_DELETED: "Message deleted",
    TXT_MEDIA_RESEND: "Resend",
    TXT_MEDIA_CONTINUE: "Continue",
    TXT_MEDIA_CONFIRM_DELETE_TITLE: "Confirm delete message",
    TXT_MEDIA_CONFIRM_DELETE_CONTENT: "Do you want to delete this message?",
    TXT_MEDIA_CONFIRM_CANCEL_TITLE: "Confirm cancel sending",
    TXT_MEDIA_CONFIRM_CANCEL_CONTENT: "Do you want to cancel sending this message?",
    TXT_MEDIA_CONFIRM_BTN: "Confirm",
    TXT_MEDIA_COL_MESSAGE: "Message",
    TXT_MEDIA_COL_STATUS: "Status",
    TXT_MEDIA_COL_TIME: "Time",
    TXT_MEDIA_COL_ACTION: "Action",
    TXT_MEDIA_STATISTIC_TITLE: "Statistics",
    TXT_MEDIA_TOTAL_SENT: "Total messages sent",
    TXT_MEDIA_SEND_SUCCESS_RATE: "Send success rate",
    TXT_MEDIA_TOTAL_RECEIVED: "Total recipients",
    TXT_MEDIA_RECEIVE_SUCCESS_RATE: "Receive success rate",
    TXT_MEDIA_TOTAL_READ: "Total readers",
    TXT_MEDIA_READ_RATE: "Read rate",

    // BotAccountDialog
    TXT_MEDIA_ACCOUNT_NAME: "Account name",
    TXT_MEDIA_ACCOUNT_NAME_PLACEHOLDER: "Enter account name",
    TXT_MEDIA_DESCRIPTION: "Description",
    TXT_MEDIA_UPLOAD_AVATAR: "Upload photo",

    // System const labels
    TXT_BRANCH_STATUS_ALL: "All",
    TXT_BRANCH_STATUS_PENDING: "Pending approval",
    TXT_BRANCH_STATUS_ACCEPTED: "Accepted",
    TXT_BRANCH_STATUS_REJECTED: "Rejected",
    TXT_BOT_STATUS_PENDING: "Scheduled",
    TXT_BOT_STATUS_SUCCESS: "Sent",
    TXT_BOT_STATUS_CANCELED: "Canceled",
    TXT_BOT_STATUS_DRAFT: "Draft",
    TXT_BOT_STATUS_FAILED: "Send failed",
    TXT_GROUP_TYPE_INBOX: "Direct message",

    // ConferenceManagement filters
    TXT_FILTER_ALL: "All",
    TXT_FILTER_OTHER: "Other",

    // UserRequestManagement
    TXT_REQUEST_CONFIRM_REMOVE_REJECT: "Confirm remove rejection status",
    TXT_REQUEST_CONFIRM_REMOVE_REJECT_CONTENT: "Do you want to remove the rejection status of {{phone}}?",
    TXT_REQUEST_REJECT_TITLE: "Reject join request",
    TXT_REQUEST_REJECT_CONTENT: "Do you want to reject the join request of {{phone}}?",

    // UserManagement tabs
    TXT_TAB_USER_LIST: "User list",
    TXT_TAB_PENDING_LIST: "Pending approval",
    TXT_TAB_REJECTED_LIST: "Rejected list",
    TXT_TOTAL_USERS_COUNT: "Total users: {{count}}",

    // Settings - Theme
    TXT_THEME_CONFIG: "Theme configuration",
    TXT_THEME_LIGHT: "Light mode",
    TXT_THEME_DARK: "Dark mode",
    TXT_THEME_SYSTEM: "Device",

    // ConferenceManagement
    TXT_APP_LIST: "Application list",
    TXT_ADMIN_LIST: "Administrator list",
    TXT_USER_LIST_LABEL: "User list",
    TXT_REMOVE_MEMBER: "Remove member",
    TXT_APP_CONFIG_DESC: "*Configuration will apply to lock screen, app list screen, main screen, and product info screen of {{appName}}",
    TXT_APP_TITLE_SECTION: "Application title",
    TXT_TITLE_REQUIRED: "Title (*)",
    TXT_SUBTITLE: "Subtitle",

    // SystemTracking
    TXT_SEARCH_BUTTON: "Search",

    // Settings - ServerInformation
    TXT_SERVER_INFO: "Server information",
    TXT_CONTENT: "Content",
    TXT_PREVIEW: "Preview",
    TXT_QR_SERVER: "Server QR code",
    TXT_CREATE_QR: "Create new QR code",
    TXT_SAVE_QR: "Save QR code",
    TXT_IMAGE_TOO_LARGE: "Image exceeds the allowed size",
    TXT_QR_EXPIRED: "QR code has expired, please refresh",
    TXT_QR_VALID_UNTIL: "QR code is valid until {{date}}",
  },

  deviceManagement: {
    TXT_DEVICE_MANAGEMENT_TITLE: "Device Management",
    TXT_DEVICE_DETAIL_TITLE: "Device Detail",
    TXT_DEVICE_LOADING: "Loading...",
    TXT_DEVICE_NOT_FOUND: "Device information not found.",
    TXT_DEVICE_SEARCH_PLACEHOLDER: "Search by account name or phone number",
    TXT_DEVICE_FILTER_TYPE: "Device type",
    TXT_DEVICE_FILTER_OS: "Operating system",
    TXT_DEVICE_FILTER_VERSION: "Version",
    TXT_DEVICE_SELECT_ALL: "SELECT ALL DEVICES",
    TXT_DEVICE_DESELECT_ALL: "DESELECT ALL",
    TXT_DEVICE_HEADER_ACCOUNT: "Account name",
    TXT_DEVICE_HEADER_NAME: "Device name",
    TXT_DEVICE_HEADER_PHONE: "Phone",
    TXT_DEVICE_HEADER_ROLE: "Role",
    TXT_DEVICE_HEADER_TYPE: "Type",
    TXT_DEVICE_HEADER_OS: "OS",
    TXT_DEVICE_HEADER_STATUS: "Status",
    TXT_DEVICE_HEADER_FIRST_LOGIN: "First login",
    TXT_DEVICE_HEADER_VERSION: "Version",
    TXT_DEVICE_HEADER_LAST_ACTIVITY: "Last activity",
    TXT_DEVICE_HEADER_ACTIONS: "Actions",
    TXT_DEVICE_ACTION_LOGOUT: "LOGOUT",
    TXT_DEVICE_ACTION_BLOCK: "BLOCK",
    TXT_DEVICE_ACTION_UNBLOCK: "UNBLOCK",
    TXT_DEVICE_BLOCK_SUCCESS: "Device blocked successfully",
    TXT_DEVICE_BLOCK_FAIL: "Failed to block device",
    TXT_DEVICE_BLOCK_ERROR: "Error blocking device",
    TXT_DEVICE_UNBLOCK_SUCCESS: "Device unblocked successfully",
    TXT_DEVICE_UNBLOCK_FAIL: "Failed to unblock device",
    TXT_DEVICE_UNBLOCK_ERROR: "Error unblocking device",
    TXT_DEVICE_LOGOUT_SUCCESS: "Device logged out successfully",
    TXT_DEVICE_LOGOUT_FAIL: "Failed to logout device",
    TXT_DEVICE_LOGOUT_ERROR: "Error logging out device",
    TXT_DEVICE_FETCH_ERROR: "Error loading device list",
    TXT_DEVICE_CONFIRM_LOGOUT_SINGLE: "Are you sure you want to logout this device?",
    TXT_DEVICE_CONFIRM_BLOCK_SINGLE: "Are you sure you want to block this device?",
    TXT_DEVICE_CONFIRM_UNBLOCK_SINGLE: "Are you sure you want to unblock this device?",
    TXT_DEVICE_DETAIL_INFO: "DEVICE INFORMATION",
    TXT_DEVICE_DETAIL_ACCOUNT_INFO: "ACCOUNT INFORMATION",
    TXT_DEVICE_DETAIL_ACTIVITY: "ACTIVITY",
    TXT_DEVICE_DETAIL_LAST_ACTIVITY: "Last activity",
    TXT_DEVICE_DETAIL_FIRST_LOGIN: "First login",
    TXT_DEVICE_DETAIL_ACTIVE_NOW: "Active now",
    TXT_DEVICE_LABEL_ACCOUNT_NAME: "Account name",
    TXT_DEVICE_LABEL_EMAIL: "Email",
    TXT_DEVICE_LABEL_PHONE: "Phone number",
    TXT_DEVICE_LABEL_ADDRESS: "Address",
    TXT_DEVICE_LABEL_UNIT: "Unit",
    TXT_DEVICE_LABEL_DEPARTMENT: "Department",
    TXT_DEVICE_LABEL_DEVICE_NAME: "Device name",
    TXT_DEVICE_LABEL_OS: "Operating system",
    TXT_DEVICE_LABEL_OS_VERSION: "OS version",
    TXT_DEVICE_LABEL_APP_VERSION: "Trios version",
    TXT_DEVICE_STATUS_BLOCKED: "Blocked",
    TXT_DEVICE_STATUS_ACTIVE: "Active",
    TXT_DEVICE_STATUS_ABSENT: "Absent",
    TXT_DEVICE_STATUS_LOGGED_OUT: "Logged out",
    TXT_DEVICE_ROLE_MASTER: "Master",
    TXT_DEVICE_ROLE_SECONDARY: "Secondary",
    TXT_DEVICE_TAB_ACTIVE_LIST: "DEVICE LIST",
    TXT_DEVICE_TAB_BLOCKED_LIST: "BLOCKED LIST",
    TXT_DEVICE_TIME_JUST_NOW: "Just now",
    FM_DEVICE_SELECTED_COUNT: "{{count}} device(s) selected",
    FM_DEVICE_CONFIRM_LOGOUT_BULK: "Are you sure you want to logout {{count}} device(s)?",
    FM_DEVICE_CONFIRM_BLOCK_BULK: "Are you sure you want to block {{count}} device(s)?",
    FM_DEVICE_CONFIRM_UNBLOCK_BULK: "Are you sure you want to unblock {{count}} device(s)?",
    FM_DEVICE_TIME_MINUTES_AGO: "{{count}} minute(s) ago",
    FM_DEVICE_TIME_HOURS_AGO: "{{count}} hour(s) ago",
    FM_DEVICE_TIME_DAYS_AGO: "{{count}} day(s) ago",
  },
};

export default en;
